var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('v-container',{attrs:{"bg":"","fill-height":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","wrap":""}},[_c('v-col',{attrs:{"md":"12","sm":"12"}},[_c('v-row',[_vm._t("default")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }